import { useCommunityId } from '@/hooks/communities';
import { useUnit } from '@/hooks/units';
import ApplyPage from '@/pages/ApplyPage';
import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { z } from 'zod';

const searchSchema = z.object({
  unitId: z.number().min(1),
});

export const Route = createFileRoute('/_layout/apply')({
  component: ApplyPage,
  validateSearch: zodValidator(searchSchema),
  loaderDeps: ({ search }) => search,
  loader: async ({ context: { queryClient }, deps: { unitId } }) => {
    const data = await useCommunityId.ensureQueryData(queryClient);
    if (data?.communityId) {
      await useUnit.ensureQueryData(queryClient, [data.communityId, unitId]);
    }
  },
});
